export const Configs = {
    DECIMAL_NUM_FORMAT: '#0.#####'
}